import { expValEquals } from '@atlassian/jira-feature-experiments';

// eslint-disable-next-line jira/ff/inline-usage
export function isInMentionsIndicatorExperimentCohort(): boolean {
	return expValEquals('mentions_in_board_and_backlog_ver_2', 'cohort', 'test');
}
